import React from "react";
import { Wrapper } from "./CloserBoardEntity.styled";
import { Row, Col } from "components/common";
import SampleImage from "../../../../assets/svg/user.svg";

const CloserBoardEntity = ({ data, location, rank }) => {
  let address = location?.filter((el) => el?._id.toString() === data?.locationId);
  return (
    <Wrapper>
      <Row gutter={[10, 10]} className="rank-section">
        <Col className="rank-title" xs={6} sm={5} md={5} lg={6}>
          <div className="ranker-image">
            <span>{rank}</span>
            <img src={data?.profilePicture ? data.profilePicture : SampleImage} alt="" />
          </div>
        </Col>
        <Col className="rank-title" xs={8} sm={9} md={9} lg={8}>
          <div className="ranker-info">
            <h5>{data?.username}</h5>
            <span>
              {address?.[0]?.name}, {address?.[0]?.state}
            </span>
          </div>
        </Col>
        <Col className="rank-title" xs={5} sm={5} md={5} lg={5}>
          <span>{data?.totalRepLeads} </span>
        </Col>
        <Col className="rank-title" xs={5} sm={5} md={5} lg={5}>
          <span>{data?.totalRepProjectKw} KW</span>
        </Col>
      </Row>
    </Wrapper>
  );
};

export default CloserBoardEntity;
